import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const AnimateLoading = () => {
  const location = useLocation();
  const [width, setWidth] = useState(0);
  const [routeChanged, setRouteChanged] = useState(false);
  const animateTimeoutRef = useRef(null);
  const stopAnimateTimeoutRef = useRef(null);

  useEffect(() => {
    if (routeChanged) {
      animate();
      //scrollToTop();
      setRouteChanged(false);
    }
  }, [routeChanged]);

  useEffect(() => {
    setRouteChanged(true);
  }, [location.pathname]);

  // const scrollToTop = () => {
  //   const scrollToTopBtn = document.getElementById("kt_scrolltop");
  //   if (scrollToTopBtn) {
  //     scrollToTopBtn.click();
  //   }
  // };

  const animate = () => {
    animateTimeoutRef.current = setTimeout(() => {
      if (width <= 100) {
        setWidth((prevWidth) => prevWidth + 10);
        animate();
      } else {
        stopAnimate();
      }
    }, 30);
  };

  const stopAnimate = () => {
    clearTimeout(animateTimeoutRef.current);
    stopAnimateTimeoutRef.current = setTimeout(() => {
      setWidth(0);
    }, 300);
  };

  useEffect(() => {
    return () => {
      if (stopAnimateTimeoutRef.current) {
        clearTimeout(stopAnimateTimeoutRef.current);
      }
      if (animateTimeoutRef.current) {
        clearTimeout(animateTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="header-progress-bar" style={{ height: "3px", width: "100%" }}>
      {width > 0 && <ProgressBar variant="info" now={width} style={{ height: "3px" }} />}
    </div>
  );
};

export default AnimateLoading;
